import { Mutation } from 'react-apollo'
import loanPayment, {
  LoanPayment,
  LoanPaymentInput
} from '../../graphql/mutations/loanPayment'
import withMutation from './withMutation'

class LoanPaymentMutation extends Mutation<LoanPayment, LoanPaymentInput> {}

export default withMutation(loanPayment)(LoanPaymentMutation)



// WEBPACK FOOTER //
// ./src/components/mutations/LoanPaymentMutation.tsx